<script setup lang="ts">
defineProps<{
  securitasLoader?: boolean
  size?: string
  color?: string
  dim?: boolean
}>()
</script>

<template>
  <div class="absolute z-50 flex items-center justify-center">
    <div v-if="securitasLoader" class="flex space-x-1">
      <span
        :class="`${size ?? 'size-8'} animate-loader rounded-full bg-signal-red-500`" />
      <span
        :class="`${size ?? 'size-8'} animation-delay-200 animate-loader rounded-full bg-signal-red-500`" />
      <span
        :class="`${size ?? 'size-8'} animation-delay-400 animate-loader rounded-full bg-signal-red-500`" />
    </div>
    <div
      v-else
      :class="`${size ?? 'size-8'} flex animate-spin gap-spacing-xs rounded-full border-2 ${color ?? 'border-black'} border-e-transparent`" />
  </div>
</template>
